<template>
  <div class="custom-wrapper" :class="{active: visible || visible2 || visible3 || visible4}">
    <div class="position: relative;">
      <!-- .custom-text-type-1 === ctt1 -->
      <popper :show-popper="visible" @close="visible=false" placement="right-start" :index="index">
        <div class="ctt1">
          <div class="ctt1-box custom-item" style="padding: 0;">
            <!-- 关闭按钮 -->
            <i class="icon iconfont icon-close-c custom-close" @click="close()"></i>
            <div class="cct1-box-content" @click.prevent="setVisible()">
              <img :src="coverImg" v-if="coverImg && Modal.link" class="cct1-box-img" />
              <video v-else-if="!coverImg && Modal.link" :src="Modal.link" class="cct1-box-img"></video>
              <img src="@assets/img/custom/video.png" v-else class="cct1-box-img" />
              <div class="cct1-box-content-mask" v-if="Modal.link">
                <div class="icon iconfont icon-arrfill_d-copy-copy"></div>
              </div>
            </div>
          </div>
        </div>
        <div slot="content" class="ctt1-poptip">
          <div class="ctt1p-title">视频设置</div>
          <div class="ctt1p-content">
            <!-- <div style="word-break: break-all;white-space: pre-wrap;">{{JSON.stringify(uploadList)}}</div> -->
            <!-- 内容区 -->
            <Form :label-width="100" :rules="ruleInline">
              <FormItem label="本地视频：" :required="true">
                <div
                  class="my-upload-list"
                  v-for="(item, index) in uploadList"
                  :key="'upload' + index"
                  style="width: 100px;height:100px;position: relative;"
                >
                  <template v-if="item.status === 'finished'">
                    <img v-if="coverImg" :src="coverImg" style="width: 100px;height:100px;" />
                    <video v-else :src="Modal.link" style="width: 100px;height:100px;"></video>
                    <div class="my-upload-list-cover">
                      <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                      <Icon
                        type="ios-trash-outline"
                        @click.native.stop.prevent="handleRemoveByArr(item)"
                      ></Icon>
                    </div>
                  </template>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :on-success="handleSuccess"
                  :format="['mp4']"
                  :max-size="51200"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-error="handleUploadError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  :on-progress="handleUploading"
                  :action="uploadVideoUrl"
                  type="drag"
                  style="display: inline-block;width: 100px;height:100px;"
                  v-show="uploadList && uploadList.length < 1"
                >
                  <div style="width: 100px;height:100px;padding-top: 15px;">
                    <div style="font-size:20px">
                      +
                      <p style="font-size:14px">上传</p>
                    </div>
                  </div>
                  <!-- 蒙版 -->
                  <div
                    v-if="showHome"
                    style="position:absolute;opacity:0;width:150px;height:100px;left:0;top:0;"
                    @click.stop="selectType"
                  ></div>
                </Upload>
                <div class="uploading" v-if="uploading">
                  <Spin>
                    <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                  </Spin>
                </div>
                <p class="upload-p" style="font-size:12px;">（视频要求：不超过50M的MP4格式，建议时长9~30s，宽高比16:9）</p>
              </FormItem>
              <!-- <FormItem label="封面：">
                <RadioGroup v-model="formInline.cover" @on-change="changeCoverType">
                  <Radio size="large" label="0">截取</Radio>
                  <Radio size="large" label="1">自定义</Radio>
                </RadioGroup>
              </FormItem>-->
              <!-- <div style="margin-top: 20px;">
                <div v-if="formInline.cover === '0'">
                  <FormItem label="截取帧：">
                    <RadioGroup v-model="picture" type="button" @on-change="pictureChange">
                      <Radio label="5秒"></Radio>
                      <Radio label="10秒"></Radio>
                      <Radio label="15秒"></Radio>
                      <Radio label="20秒"></Radio>
                      <Radio label="25秒"></Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem label="预览：">
                    <div class="preview-box" style="margin-left: 100px">
                      <img :src="this.coverImg" v-if="coverImg" style="width: 100px;height:100px;" />
                      <img
                        src="@assets/img/custom/video.png"
                        v-else
                        style="width: 100px;height:100px;"
                      />
                    </div>
                  </FormItem>
                </div>

                <FormItem v-if="formInline.cover === '1'">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList2"
                    :key="'upload' + index"
                    style="width: 100px;height:100px;"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width: 100px;height:100px;" />
                      <div class="my-upload-list-cover">
                        <Icon
                          type="ios-trash-outline"
                          @click.native.stop.prevent="handleRemoveByArr2(item)"
                        ></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 100px;height:100px;">
                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload2"
                    :show-upload-list="false"
                    :on-success="handleSuccess2"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError2"
                    :on-exceeded-size="handleMaxSize2"
                    :before-upload="handleBeforeUpload2"
                    type="drag"
                    :action="uploadUrl"
                    multiple
                    style="display: inline-block;width: 100px;height:100px;"
                    v-show="uploadList2 && uploadList2.length < 1"
                  >
                    <div style="width: 100px;height:100px;padding-top: 15px;">
                      <div style="font-size:20px">
                        +
                        <p style="font-size:14px">上传</p>
                      </div>
                    </div>
                    <div
                      style="position:absolute;opacity:0;width:150px;height:100px;left:0;top:0;"
                      @click.stop="selectType2"
                    ></div>
                  </Upload>
                  <p style="font-size: 12px;">(图片要求：2M以下的jpg或png，建议尺寸750*500px)</p>
                </FormItem>
              </div>-->
            </Form>
            <div style="text-align:right;">
              <Button type="primary" @click.prevent="setVisible()">暂存</Button>
            </div>
            <!-- 内容区 end -->
          </div>
        </div>
      </popper>
      <!-- 上方增加键 -->
      <Poptip
        v-model="visible2"
        placement="right-start"
        width="411"
        class="custom-add-wrapper z-top"
      >
        <img src="@/assets/img/custom/add.png" />
        <div slot="content" class="ctt1-poptip">
          <div class="ct-components">
            <div class="ctc-title">新增组件</div>
            <div class="ctc-group" v-if="commmonType===1">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr"
                :key="'commmon-' + index"
                @click="add(item, 'top')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
            <div class="ctc-group" v-if="commmonType===2">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr2"
                :key="'commmon-' + index"
                @click="add(item, 'top')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </Poptip>
      <!-- 下方增加键 -->
      <Poptip
        v-model="visible3"
        placement="right-start"
        width="411"
        class="custom-add-wrapper z-bottom"
      >
        <img src="@/assets/img/custom/add.png" />
        <div slot="content" class="ctt1-poptip">
          <div class="ct-components">
            <div class="ctc-title">新增组件</div>
            <div class="ctc-group" v-if="commmonType===1">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr"
                :key="'commmon-' + index"
                @click="add(item, 'bottom')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
            <div class="ctc-group" v-if="commmonType===2">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr2"
                :key="'commmon-' + index"
                @click="add(item, 'bottom')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </Poptip>
      <iModal
        cancel-text
        v-model="visible4"
        class-name="vertical-center-modal"
        :footer-hide="false"
        :z-index="1100"
      >
        <div style="text-align: center;">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
          ></video-player>
        </div>
      </iModal>
    </div>
    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />
    <videoUpload
      @upload:local="uploadVideoLocal"
      @upload:material="uploadVideoMaterial"
      :maxCount="1"
      v-model="uploadVideoFlag"
    />
  </div>
</template>

<script>
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import { mapActions, mapGetters, mapMutations } from "vuex";
import { videoPlayer } from "vue-video-player";
import popper from "@components/vue-popper/VuePopper.vue";
import imgUpload from "@components/imgUpload/imgUpload.vue";
import videoUpload from "@components/uploadVideoChoose/uploadVideoChoose.vue";
export default {
  // 图片类型 1
  name: "custom-video-type-1",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    Modal: {
      type: Object,
      default: function() {
        return {
          type: 1, // 视频类型 暂时只有 1
          cover: "", // 封面
          time: 5000, // 视频封面截取帧
          link: "", // 视频地址
          coverType: "0" // 视频封面累心 0 截取 1 自定义
        };
      }
    },
    index: {
      type: Number,
      default: 0
    },
    info: {
      type: Object,
      default: {
        type: 1, // 视频类型 暂时只有 1
        cover: "", // 封面
        time: 5000, // 视频封面截取帧
        link: "", // 视频地址
        coverType: "0" // 视频封面累心 0 截取 1 自定义
      }
    },
    commmonType: {
      // 通用添加组件的列表   1：所有列表   2：筛选列表
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      uploadChooseShowed: false,
      uploadVideoFlag: false,
      showModal: false,
      loading: false,
      uploading: false,
      uploadList: [],
      uploadList2: [],
      visible: false,
      formInline: {
        cover: "0",
        name: ""
      },
      picture: "5秒", // 视频封面的帧数
      coverImg: "",
      videoData: null,
      ruleInline: {},

      visible: false,
      visible2: false,
      visible3: false,
      visible4: false,

      commmonArr: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "标题",
          icon: "icon-biaoti",
          type: "title",
          componentName: "customTitle",
          config: {
            type: 1, // 标题类型 暂时只有 1
            content: "",
            position: "left", // 文本对齐格式
            padding: "12px", // 标题的边距
            fontSize: "12px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色
            link: {
              type: "3",
              value: ""
            }
          }
        },
        {
          title: "链接",
          icon: "icon-link",
          type: "link",
          componentName: "customLink",
          config: [
            {
              type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
              name: "",
              url: ""
            }
          ]
        },
        {
          title: "产品搜索",
          icon: "icon-sousuo",
          type: "search",
          componentName: "customSearch",
          config: {
            type: 1, // 搜索类型 暂时只有 1
            words: ["热词1", "热词2"],
            style: "circular", // 搜索外边框样式 （圆 \ 方）
            position: "left", // 文本对齐格式
            color: "#ccc",
            background: "#f5f5f5",
            borderColor: "#91c0ec"
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ],
      commmonArr2: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ]
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    activeIndex(val, oldVal) {
      if (val !== this.index) this.visible = false;
    },
    Modal(val, oldVal) {
      this.init();
    }
  },
  created() {
    this.init();
    if (this.index === this.activeIndex) {
      this.visible = true;
    }
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      activeIndex: "customComponentModule/getActiveIndex"
    }),
    // videoImg() {
    //   let url = "";
    //   if (this.uploadList && this.uploadList.length) {
    //     let suffix =
    //       "?x-oss-process=video/snapshot,t_2000,f_jpg,w_590,h_332,m_fast";
    //     url = this.uploadList[0].url + suffix;
    //   }
    //   return url;
    // },
    playerOptions() {
      let res = {};
      if (this.videoData) {
        res = {
          autoplay: false,
          muted: false,
          loop: false,
          preload: "auto",
          language: "zh-CN",
          aspectRatio: "16:9",
          fluid: true,
          sources: [
            {
              type: "video/mp4",
              src: this.videoData.url
            }
          ],
          poster: this.coverImg,
          width: document.documentElement.clientWidth,
          notSupportedMessage: "此视频暂无法播放，请稍后再试"
        };
      }
      return res;
    },
    type() {
      return this.info.type;
    },
    haveVideo() {
      let bool = this.uploadList.length > 0 ? true : false; 
      return bool;
    },
    showHome() {
      let bool = true;
      if (this.$route.path.indexOf("/host/index") !== -1) {
        bool = false;
      }
      if (this.$route.path.indexOf("/host/project") !== -1) {
        bool = false;
      }
      return bool;
    },
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customComponentModule/setActiveIndex"
    }),
    ...mapActions({
      addvideoMaterial: "materialModule/addvideoMaterial"
    }),
    // 选择视频上传方式
    selectType() {
      this.uploadVideoFlag = true;
    },
    // 选择图片上传方式
    selectType2() {
      this.uploadChooseShowed = true;
    },
    init() {
      this.uploadList = [];
      this.uploadList2 = [];
      this.formInline.cover = this.Modal.coverType;
      if (this.formInline.coverType === "0") {
        switch (this.Modal.time) {
          case 5000:
            this.picture = "5秒";
            break;
          case 10000:
            this.picture = "10秒";
            break;
          case 15000:
            this.picture = "15秒";
            break;
          case 20000:
            this.picture = "20秒";
            break;
          case 25000:
            this.picture = "25秒";
            break;
        }
      }
      this.coverImg = this.Modal.cover; 
      if (this.Modal.coverType === "1") {
        if (this.Modal.cover) {
          this.uploadList2 = [
            {
              name: 1,
              url: this.Modal.cover,
              status: "finished",
              percentage: 100
            }
          ];
        }
      }
      if (this.Modal.link) {
        this.uploadList = [
          {
            name: 1,
            url: this.Modal.link,
            status: "finished",
            percentage: 100
          }
        ];
      }
    },
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    changeCoverType() {
      this.Modal.coverType = this.formInline.cover;
    },
    popperHide() {},
    addComponent() {
      this.visible = false;
    },
    add(item, index) {
      // top 表示在上面添加  bottom表示下面添加
      let idx = this.index;
      if (index === "bottom") {
        idx = this.index + 1;
      }
      this.$emit("add", item, idx);
      this.visible = false;
      this.visible2 = false;
      this.visible3 = false;
      this.visible4 = false;
      
      
    },
    close() {
      this.$emit("close");
    },
    handleSuccess(res, file) {
      this.uploading = false;
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
        // this.coverImg =
        //   this.uploadList[0].url +
        //   `?x-oss-process=video/snapshot,t_${5000},f_jpg,w_590,h_332,m_fast`;
        this.formInline.name = this.uploadList[0].name;
        this.Modal.link = this.uploadList[0].url;
        this.Modal.cover = this.coverImg;
        this.Modal.time = 5000;
      }
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
        this.coverImg = this.uploadList2[0].url;
        this.Modal.cover = this.uploadList2[0].url;
      }
    },
    // 查看上传图片
    handleView(name) {
      this.videoData = name;
      this.visible4 = true;
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传mp4格式的视频`);
      this.uploading = false;
    },
    handleUploadError(file) {
      this.$Message.warning({
        content: "您的网络请求已超时,请重新上传",
        duration: 3,
        closable: true
      });
      this.uploading = false;
    },
    handleFormatError2(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于50M以下mp4格式的视频`);
    },
    handleMaxSize2(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleRemoveByArr2(file) {
      const fileList2 = this.uploadList2;
      this.uploadList2.splice(fileList2.indexOf(file), 1);
    },
    handleBeforeUpload() {
      this.uploading = true;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`一次只能上传${limitNum}条视频`);
      }
      return check;
    },
    handleBeforeUpload2() {
      const check = this.$refs.upload2.fileList.length < 1;
      if (!check) {
        this.$Message.warning(`最多只能上传1张封面`);
      }
      return check;
    },
    handleUploading(event) {},
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    transfromImgList2(arr) {
      let arr2 = [];
      arr.forEach(c => {
        let url = c.url;
        if (this.formInline.cover === "0") {
          let suffix =
            "?x-oss-process=video/snapshot,t_2000,f_jpg,w_590,h_332,m_fast";
          url += suffix;
        }
        arr2.push(url);
      });
      return arr2;
    },
    close() {
      this.showModal = false;
      this.loading = false;
      this.uploadList = [];
      this.uploadList2 = [];
      this.visible4 = false;
      this.videoData = null;
      this.coverImg = "";
      this.from = "";
      this.formInline.cover = "0";
      this.formInline.name = "";
      this.uploading = false;
      if (this.$refs["upload"]) this.$refs["upload"].clearFiles();
      if (this.$refs["upload2"]) this.$refs["upload2"].clearFiles();
      this.$emit("close");
    },
    onPlayerPlay(player) {},
    onPlayerPause(player) {},
    pictureChange(e) {
      let second = this.getIntArr(e);
      if (this.uploadList[0] && this.uploadList[0].url) {
        this.coverImg =
          this.uploadList[0].url +
          `?x-oss-process=video/snapshot,t_${second[0] *
            1000},f_jpg,w_590,h_332,m_fast`;
        this.Modal.cover = this.coverImg;
        this.Modal.time = second[0] * 1000;
      }
    },
    getIntArr(str) {
      return str
        .replace(/[^0-9]/gi, " ")
        .trim()
        .split(/\s+/);
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList2.length >= 1) {
          this.$Message.warning(`最多上传1张图片`);
          this.uploadChooseShowed = false;
          return;
        } else {
          this.uploadList2.push({
            status: "finished",
            url: item
          });
          this.picItem.url = item;
          this.uploadChooseShowed = false;
        }
      }
    },
    uploadVideoLocal() {
      this.$refs.upload.handleClick();
    },
    uploadVideoMaterial(e) { 
      const copyModal = JSON.parse(JSON.stringify(this.Modal));
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`最多上传1段视频`);
          return;
        } else {
          if (item.Link) {
            this.uploadList.push({
              status: "finished",
              url: item.Link,
              src: item.Img
            });
            copyModal.link = item.Link;
            copyModal.cover = item.Img;
          } else {
            this.uploadList.push({
              status: "finished",
              url: item.path,
              src: item.src
            });
            copyModal.link = item.path;
            copyModal.cover = item.src;
          }
        }
        if (item.Cover === "0") {
          this.Modal.coverType = "0";
          copyModal.coverType = "0";
        } else {
          this.Modal.coverType = "1";
          copyModal.coverType = "1";
        }
      }
      this.coverImg = this.uploadList[0].src;

      this.$emit("changeModal", copyModal);
    }
  },
  mounted() {
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
    if (this.index === 0) {
      this.visible = true;
      this.setActiveIndex(this.index);
    }
  },
  components: {
    popper,
    videoPlayer,
    imgUpload,
    videoUpload
  }
};
</script>
 
<style scoped lang="scss">
.cct1-box-img {
  display: inline-block;
  width: 100%;
  height: 100%;
  min-height: 200px;
}
.cct1-box-content {
  height: 200px;
  position: relative;
  &-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(55, 55, 55, 0.6);
    height: 100%;
    .iconfont {
      color: #fff;
      padding-top: 83px;
      text-align: center;
      font-size: 50px;
    }
  }
}
.ctt1 {
  width: 100%;
  &-box {
    background-color: #fff;
    cursor: pointer;
    &-content {
      padding: 0;
      margin: 0;
    }
  }
  &-poptip {
    min-height: 60px;
    .ctt1p {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-content {
        padding: 20px 30px;
        white-space: normal;
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.upload-p {
  font-size: 12px;
  line-height: 1.2;
  padding-top: 10px;
}

.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.video-player {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}
.my-upload-list-cover {
  i {
    position: relative !important;
    top: -2px !important;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

.preview-box {
  width: 100px;
  height: 100px;
  background-color: #bfbfbf;
  border-radius: 5px;
  position: relative;
  img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
